/**
 * The HOOPIFY wordmark: Unbounded 900, skewed −8°, gradient fill with a fluro
 * blue copy offset behind it. Text only, no symbol. The shadow drops out below
 * 20px, as the style guide says.
 */
export function Wordmark({ size = 24, className = '' }: { size?: number; className?: string }) {
  const shadow = size >= 20;
  return (
    <span
      className={`inline-grid leading-none ${className}`}
      style={{ fontFamily: 'var(--font-display)', fontWeight: 900, fontSize: size, letterSpacing: '-0.02em', transform: 'skewX(-8deg)' }}
    >
      {shadow && (
        <span aria-hidden className="text-blue" style={{ gridArea: '1 / 1', transform: 'translate(0.065em, 0.065em)' }}>
          HOOPIFY
        </span>
      )}
      <span className="text-brand-gradient relative" style={{ gridArea: '1 / 1' }}>
        HOOPIFY
      </span>
    </span>
  );
}

/** COACH · PLAN · DEVELOP · WIN, with the short gradient bar. */
export function Tagline({ size = 12, className = '' }: { size?: number; className?: string }) {
  return (
    <span className={`flex items-center font-bold text-ink ${className}`} style={{ fontSize: size, letterSpacing: '0.32em', gap: '0.8em' }}>
      <i aria-hidden className="bg-brand-gradient rounded-full" style={{ width: '3em', height: '0.28em' }} />
      COACH · PLAN · DEVELOP · WIN
    </span>
  );
}
